export const DHL_D2SVP_SERVICE_CODES = [
    'DHLD2SVPECX',
    'DHLD2SVPWPXDAP',
    'DHLD2SVPWPXDDP',
    'DHLD2SVPESU',
    'DHLD2SVPESIDAP',
    'DHLD2SVPESIDDP'
] as const;

export type DhlD2svpServiceCode = (typeof DHL_D2SVP_SERVICE_CODES)[number];

export type DhlD2svpScope = 'eu' | 'nonEu';

export const DHL_D2SVP_SCOPE: Record<DhlD2svpServiceCode, DhlD2svpScope> = {
    DHLD2SVPECX: 'eu',
    DHLD2SVPWPXDAP: 'nonEu',
    DHLD2SVPWPXDDP: 'nonEu',
    DHLD2SVPESU: 'eu',
    DHLD2SVPESIDAP: 'nonEu',
    DHLD2SVPESIDDP: 'nonEu'
};

const DHL_D2SVP_SERVICE_CODE_SET = new Set<string>(DHL_D2SVP_SERVICE_CODES);

export const isDhlD2svpServiceCode = (code: string | null | undefined): code is DhlD2svpServiceCode =>
    typeof code === 'string' && DHL_D2SVP_SERVICE_CODE_SET.has(code);
